import { render, staticRenderFns } from "./myProfit.vue?vue&type=template&id=38ac6510&scoped=true&"
import script from "./myProfit.vue?vue&type=script&lang=js&"
export * from "./myProfit.vue?vue&type=script&lang=js&"
import style0 from "./myProfit.vue?vue&type=style&index=0&id=38ac6510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac6510",
  null
  
)

export default component.exports